import { Filters } from "@/types/filters";
import React, { useMemo } from "react";
import { UrlStateProvider as BaseUrlStateProvider, useUrlState } from "./use-url-state";

export function UrlFiltersProvider({
	children,
	initialFilters,
}: {
	children: React.ReactNode;
	initialFilters?: Partial<Filters>;
}) {
	return <BaseUrlStateProvider initialFilters={initialFilters}>{children}</BaseUrlStateProvider>;
}

export function useUrlFilters() {
	const { state, setFilters } = useUrlState();

	const filters = useMemo(() => state.filters, [state.filters]);

	return {
		filters,
		setFilters,
	};
}
